import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=2b4dbd58&scoped=true"
import script from "./Stepper.vue?vue&type=script&lang=ts"
export * from "./Stepper.vue?vue&type=script&lang=ts"
import style0 from "./Stepper.vue?vue&type=style&index=0&id=2b4dbd58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dbd58",
  null
  
)

export default component.exports